import * as React from 'react'

import { BlocksRenderer } from '@strapi/blocks-react-renderer'
import cn from 'classnames'
import { Carousel } from 'react-responsive-carousel'
import { useRecoilValue } from 'recoil'

import getIconClass from '../../../misc/helpers/getIconClass'
import { cld } from '../../../services/CloudinaryService'
import { translate } from '../../../state/locale/selectors/translate'
import { Link } from '../../reusable/Link'
import styles from './Investment.module.scss'
import { IInvestmentProps } from './Investment.types'

export const Investment = ({ data }: IInvestmentProps) => {
  const i18n = useRecoilValue(translate).investments.page

  return (
    <div className={styles.singlePageWrapper}>
      <Carousel
        autoPlay={true}
        dynamicHeight={true}
        emulateTouch={true}
        infiniteLoop={true}
        interval={5000}
        showArrows={true}
        showIndicators={true}
        showStatus={false}
        showThumbs={false}
        swipeable={true}
        transitionTime={500}
        useKeyboardArrows={false}
        className={styles.carousel}
      >
        {data.images.map((image, index) => {
          const imageUrl = cld
            .image(image.provider_metadata.public_id)
            .format('auto')
            .quality('auto')
            .toURL()

          return (
            <div className={styles.imageContainer} key={index.toString()}>
              <img className={styles.image} src={imageUrl} alt={`Westminster ${index}`} />
            </div>
          )
        })}
      </Carousel>
      <h2 className={styles.pageTitle}>{data.title}</h2>
      <BlocksRenderer content={data.content} />
      {data.website_link && (
        <Link className={styles.buttonLink} to={data.website_link} blank={true}>
          {i18n.button}
        </Link>
      )}
      <div className={styles.social}>
        {data.facebook_link && (
          <Link className={cn(styles.icon, getIconClass.facebook)} to={data.facebook_link} blank={true} />
        )}
        {data.instagram_link && (
          <Link className={cn(styles.icon, getIconClass.instagram)} to={data.instagram_link} blank={true} />
        )}
      </div>
    </div>
  )
}
